export default function () {
    return {
        preOrders: [],
        preOrdersPerPage: 50,
    };
}
